import { Controller } from "@hotwired/stimulus";
import { i18n } from "../lib/i18n";

export default class extends Controller {
  static targets = ["fileInput", "preview", "previewContainer"];
  
  connect() {
    this.capturedFile = null;
    // Listen for file input changes (when user selects file manually)
    this.fileInputTarget.addEventListener("change", (e) =>
      this.handleFileInputChange(e),
    );
  }

  async openCamera(event) {
    event.preventDefault();

    try {
      // Create a file input that accepts camera input directly
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.capture = "environment"; // Use rear camera on mobile devices

      input.addEventListener("change", (e) => {
        const file = e.target.files[0];
        if (file) {
          this.handleCapturedImage(file);
        }
      });

      input.click();
    } catch (error) {
      console.error("Error accessing camera:", error);
      alert(i18n.t('camera_capture.unable_to_access'));
    }
  }

  handleFileInputChange(event) {
    const file = event.target.files[0];
    if (file) {
      this.showPreview(file);
    } else if (this.hasPreviewContainerTarget) {
      this.previewContainerTarget.classList.add("hidden");
    }
  }

  handleCapturedImage(file) {
    // Store the captured file
    this.capturedFile = file;

    // Immediately set the file to the file input
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    this.fileInputTarget.files = dataTransfer.files;

    // Dispatch change event so other controllers (photo-upload) can react.
    // Setting .files programmatically does not fire change automatically.
    this.fileInputTarget.dispatchEvent(new Event("change", { bubbles: true }));

    // Show preview if targets exist (not all forms have them)
    this.showPreview(file);
  }

  showPreview(file) {
    if (!this.hasPreviewTarget || !this.hasPreviewContainerTarget) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewTarget.src = e.target.result;
      this.previewContainerTarget.classList.remove("hidden");
      this.fileInputTarget.required = false;
    };
    reader.readAsDataURL(file);
  }
}
